export const partnerReleases = {
  certifyAndOpen: "Cấp chứng nhận và mở phạm vi đã duyệt",
  certificationDetails: "Căn cứ mở ({count})",

  feedTitle: "Chứng nhận Tingee chỉ đọc trên kết nối đang hoạt động",
  feedHint: "Đọc API thật và đối chiếu cùng giao dịch qua webhook, đối soát, chuẩn hoá và giao sang Shop. Đạt sẽ cấp chứng nhận 7 ngày cho webhook và đọc giao dịch; không tự mở quyền hay chứng nhận tạo liên kết mới.",
  feedLoad: "Tải kết nối Live",
  feedConnection: "Kết nối",
  feedChoose: "Chọn kết nối cần kiểm",
  feedRun: "Kiểm chỉ đọc và cấp chứng nhận",
  feedRunning: "Đang kiểm…",
  feedPassed: "Đã cấp chứng nhận",
  feedFailed: "Chưa đạt",
  keepExisting: "Giữ các khả năng đang mở khi gắn chứng nhận",

  manualTitle: "Mở thủ công khi chưa có chứng nhận",
  manualHint: "Cho phép sử dụng phạm vi đã chọn dù chưa kiểm thử đạt. Hệ thống ghi người duyệt và lý do; không tạo bằng chứng kiểm thử.",
  manualChoose: "Chọn ứng dụng, nhà cung cấp và môi trường",
  manualMarket: "Thị trường",
  manualCapabilities: "Khả năng được mở",
  manualUntil: "Hết hạn lúc (để trống = không hết hạn)",
  manualAcknowledge: "Tôi chấp nhận mở khi chưa có chứng nhận kiểm thử cho phạm vi này.",
  manualOpen: "Phê duyệt thủ công và mở",
  manualLabel: "Mở thủ công — chưa chứng nhận",

  stale: "Cấu hình/adapter đã thay đổi",
  closedCatalog: "Danh mục chưa được mở",
  noRelease: "Chưa được mở; kiểm thử cấp chứng nhận hoặc phê duyệt thủ công",
  enforce: "Chuyển sang cưỡng chế",
  enforceHint: "Chỉ chuyển sau khi consumer đã ACK đúng bản shadow hiện tại. Sau chuyển, công tắc cũ không được ghi nữa; nhà/môi trường thiếu chứng nhận hợp lệ tiếp tục đóng.",
  confirmClosed: "Tôi đã rà soát bản shadow và xác nhận giữ đóng các nhà/môi trường chưa đủ chứng nhận.",
  shadowNotice: "Một số app đang shadow: HQ đẩy chính sách để đối chiếu, chưa thay quyền đang phục vụ. Cần ACK đúng phiên bản/hash/chế độ và duyệt chuyển riêng từng app.",
  title: "Quyền mở nhà cung cấp và môi trường",
  intro: "Mở bằng chứng nhận kiểm thử hoặc phê duyệt thủ công có ghi nhận. Chọn rõ ứng dụng, nhà cung cấp, môi trường và phạm vi.",
  reload: "Tải lại",
  loading: "Đang tải quyền mở…",
  ownerApp: "Ứng dụng sở hữu",
  partner: "Nhà cung cấp",
  environment: "Môi trường",
  status: "Trạng thái",
  scopeCertification: "Phạm vi / căn cứ mở",
  revision: "Bản sửa đổi",
  actions: "Thao tác",
  enabled: "Đang mở",
  disabled: "Đã đóng",
  expired: "Hết hạn",
  revoked: "Đã thu hồi",
  valid: "Còn hiệu lực",
  noScope: "Chưa khai phạm vi",
  empty: "Chưa có quyền mở. Nhà cung cấp và môi trường vẫn đóng mặc định.",
  close: "Đóng",
  revoke: "Thu hồi",
  closeReason: "HQ tạm đóng quyền mở",
  revokePrompt: "Lý do thu hồi chứng nhận (bắt buộc):",
  revokeReasonInput: "Nhập lý do thu hồi",
  reasonRequired: "Cần nhập lý do thu hồi chứng nhận.",
  cancel: "Huỷ",
  revokeCode: "HQ_OPERATOR_REVOKED",
  retry: "Tải lại",
  profileEvidence:'Bằng chứng profile đã chạy',chooseEvidence:'Chọn lượt phát hành và tra lại',noEvidence:'Chưa có đủ bằng chứng cùng chứng từ/phiên bản',
  validUntil:'Chứng nhận hết hạn lúc',certify:'Cấp chứng nhận',certifyHint:'Chỉ profile có đầy đủ bước, cùng fixture, chứng từ, phiên bản và adapter hiện tại mới được cấp. Cấp chứng nhận không tự mở dịch vụ.',
  certification:'Chứng nhận / phê duyệt còn hiệu lực',chooseCertificate:'Chọn chứng nhận còn hiệu lực',noValidCertificate:'Chưa có chứng nhận còn hiệu lực',openReason:'Lý do mở',open:'Mở đúng phạm vi đã duyệt',
} as const;
